/**
 * Shared constants across all platforms (Native, Web, etc.)
 */

/**
 * The identifier used for local data created when in Visitor Mode (unauthenticated).
 */
export const VISITOR_ID = "visitor";

/**
 * Standard HTTP Status Codes
 */
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/**
 * The slug for the default "Inbox" list.
 */
export const INBOX_SLUG = "inbox";

/**
 * A stable reference for an empty array to prevent unnecessary re-renders in hooks.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

/**
 * Deep Linking Configuration
 */
export const APP_SCHEME = "timetracker";
export const APP_DOMAIN = "app.chronostracker.com";

/**
 * SOFT_DELETE_STANDARD — server kit: days a soft-deleted row
 * (`deleted_at`) remains in the trash before the server-side purge job
 * physically removes it (recording `purged` in `activity` with
 * snapshot). `0` disables purge (indefinite trash). See
 * infra/guides/SOFT_DELETE_STANDARD.md.
 */
export const TRASH_PURGE_DAYS = 30;
